// Частицы-кристаллы на canvas поверх всего экрана (взрыв и «дождь»). Перенесено из прототипа.
// canvas — fixed на весь экран, pointer-events: none (см. .slt-fx в slot.css).

export function createFx(cv) {
  const c = cv.getContext('2d');
  const COLS = ['#35e0ff', '#8df3ff', '#b07bff', '#ffd24a', '#ffffff', '#ff8ad1'];
  let ps = [], raf = 0, dead = false;

  const size = () => { cv.width = innerWidth; cv.height = innerHeight; };
  addEventListener('resize', size); size();

  function frame() {
    if (dead) return;
    c.clearRect(0, 0, cv.width, cv.height);
    ps = ps.filter(p => p.life > 0 && p.y < cv.height + 40);
    for (const p of ps) {
      if (p.wait > 0) { p.wait--; continue; }
      p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--;
      c.save();
      c.globalAlpha = Math.min(1, p.life / 25);
      c.translate(p.x, p.y); c.rotate(p.rot);
      c.fillStyle = p.col;
      c.beginPath(); c.moveTo(0, -p.s); c.lineTo(p.s * 0.7, 0); c.lineTo(0, p.s); c.lineTo(-p.s * 0.7, 0); c.closePath(); c.fill();
      c.fillStyle = 'rgba(255,255,255,.55)';
      c.beginPath(); c.moveTo(0, -p.s); c.lineTo(p.s * 0.7, 0); c.lineTo(0, 0); c.closePath(); c.fill();
      c.restore();
    }
    raf = ps.length ? requestAnimationFrame(frame) : 0;
  }
  const kick = () => { if (!raf && !dead) raf = requestAnimationFrame(frame); };

  function burst(x, y, n, power) {
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2, sp = (0.35 + Math.random()) * (power || 9);
      ps.push({ x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 3, g: 0.28, s: 4 + Math.random() * 9, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.4, life: 55 + Math.random() * 50, wait: 0, col: COLS[i % COLS.length] });
    }
    kick();
  }
  function rain(n) {
    for (let i = 0; i < n; i++) {
      ps.push({ x: Math.random() * cv.width, y: -20, vx: (Math.random() - 0.5) * 2, vy: 2 + Math.random() * 4, g: 0.12, s: 5 + Math.random() * 10, rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3, life: 260, wait: Math.floor(Math.random() * 90), col: COLS[i % COLS.length] });
    }
    kick();
  }
  const center = el => { const b = el.getBoundingClientRect(); return [b.left + b.width / 2, b.top + b.height / 2]; };
  function destroy() {
    dead = true;
    if (raf) cancelAnimationFrame(raf);
    removeEventListener('resize', size);
    ps = [];
  }
  return { burst, rain, center, destroy };
}
